<template>
  <div id="index">
    <div class='fixed-area'>
      <NavBarComponent @change-index='changeIndex' :current-index="current_index" :items="navBarItems"/>
    </div>
    <v-touch @swipeleft="swipeLeft" @swiperight="swipeRight" class='v-touch' :swipe-options="{direction: 'horizontal'}">
      <transition :name="transitionName" v-for="(category, index) in categorys" v-bind:key="index"> 
          <div v-show="current_index === index" class='current-page' ref='current' id='currentpage'>
            <LoadMore v-if='loading_more[index].refresh_flag'></LoadMore>
            <template v-for="(listItem, inner_index) in category">
              <div v-bind:key='inner_index'>
                <div v-if='inner_index % 2 === 0 && current_index === index' class='ad-container'></div>
                <ListItemComponent :item="listItem" @click.native="handleItemClick(inner_index)"/>
              </div>
            </template>
            <div v-if="category && category.length !== 0" class='loading-text'>{{loading_text}}</div>
          </div>
      </transition>
    </v-touch>
  </div>
</template>

<script>
import NavBarComponent from './NavBarComponent'
import ListItemComponent from "./ListItemComponent"
import LoadMore from './loadmore'
// let loading_more = [];
let touch_time = 0;
let touch_start_X = 0;
let touch_start_Y = 0;
let timer = null;
export default {
  name: 'Index',
  data: function () {
    return {
      loading_text: '加载更多...',
      loading_more: [],
      categorys: [
      ],
      navBarItems: [
      ],
      current_index: 0,
      transitionName: "slide-left",
      adcode: [
        '<script type="text/javascript" class="iclicashAD" src="//cdn.aiclk.com/jssdk/aisdk.js?aid=7141282"><\/script>',
        '<script type="text/javascript">var sogou_ad_id=991654;var sogou_ad_content_height=120;<\/script><script type="text/javascript" src="http://gif.lu.sogoucdn.com/wap/js/wp.js"><\/script>',
        '<script type="text/javascript" class="iclicashAD" src="//cdn.aiclk.com/jssdk/aisdk.js?aid=7347298"><\/script>',
        '<script type="text/javascript" data-product="20066" data-android-channal="qgsh5a2018110501xxl" data-ios-channal="qgsh5a2018110501xxl" src="//cdn.ipadview.com/jssdk/combo.bundle.js"><\/script>',
        '<script type="text/javascript" class="iclicashAD" src="//cdn.aiclk.com/jssdk/aisdk.js?aid=7248879"><\/script>'
      ]
    }
  },
  components: {
    NavBarComponent,
    ListItemComponent,
    LoadMore
  },
  mounted() {
    console.log(this.$route);
    const match_result = window.location && window.location.search && window.location.search.match(/\?user_id=(\d+)/);
    if (match_result && match_result[1]) {
      this.user_id = match_result[1];
    }
    console.log('user_id: ', this.user_id);
    if (!Promise) {
      alert('当前浏览器版本太低，不支持该任务哦(Promise)');
    } else {
      this.getNavBar();
    }
  },
  activated() {
    // 首次渲染时不设置，此时this.$refs还没有被填充，为空对象
    if (this.$refs && this.$refs.current) {
      this.$refs.current[this.current_index].scrollTop = this.scroll_position || 0;
    }
  },
  // deactivated() {
  //   console.log("index.vue deactived");
  //   console.log('this.$refs.current[this.current_index].scrollTop: ', this.$refs.current[this.current_index].scrollTop);
  //   console.log('this.$refs.current[this.current_index]: ', this.$refs.current[this.current_index]);
  //   this.scroll_position = this.$refs.current[this.current_index].scrollTop;
  // },
  methods: {
    handleItemClick: function (index) {
      // console.log('index: ', index);
      // console.log('id: ', this.categorys[this.current_index][index].id);
      // deactivated 获取到的scrollTop有时候会一直为0， 所以修改为在跳转之前获取scrollTop
      this.scroll_position = this.$refs.current[this.current_index].scrollTop;
      this.$router.push({name: 'detail', params: {story_url: encodeURIComponent((this.categorys[this.current_index][index].dataUrl)), story_related : this.categorys[this.current_index][index]}})
    },
    getNavBar: function () {
      Promise.resolve({
        data: {
          statusCode: 200,
          channelList: [
            {
              "id": 1,
              "name": "头条",
            },
            {
              "id": 2,
              "name": "社会",
            },
            {
              "id": 3,
              "name": "娱乐",
            },
            {
              "id": 4,
              "name": "历史",
            },
            {
              "id": 5,
              "name": "搞笑"
            },
            {
              "id": 6,
              "name": "健康",
            },
            {
              "id": 7,
              "name": "情感",
            }
          ]
        }
      }).then(res => {
        console.log("channel list: ", res);
        if (res.data.statusCode === 200) {
          const length = res.data.channelList.length;
          this.navBarItems = res.data.channelList;
          this.categorys = new Array(length).fill([]);
          new Array(length).fill(0).forEach((value, index) => { this.loading_more[index] = {loading_flag: false, refresh_flag: false, page_num: undefined}; });
          this.getPageInfo(this.current_index, undefined);
          this.$nextTick(() => {
            const pages = this.$refs.current;
            if (!document.addEventListener) {
              alert('当前浏览器版本太低，不支持该任务哦(addEventListener)');
            } else {
              for (let i = 0, len = pages.length; i < len; i++) {
                pages[i].addEventListener('scroll', this.throttle(this.divScrollHandler, 500, 1000));
                pages[i].addEventListener('touchstart', this.touchStart);
                pages[i].addEventListener('touchend', this.touchEnd);
              }
            }
          });
        }
      }).catch(error => {
        console.log('error: ', error);
      })
    },
    getPageInfo: function (index, page_num) {
      // if (page_num === undefined && this.categorys[index].length && this.loading_more[index].refresh_flag !== true) return;
      this.axios({
        method: 'POST',
        url: `https://api.dianxiao.feedadx.com/dianxiao/news/list`,
        data: {
          'newsChannel': this.navBarItems[index].id,
          'lastRecordId': page_num,
        }
      }).then(res => {
        console.log('res: ', res);
        if (page_num === undefined) {
          this.categorys.splice(index, 1, res.data.newsInfoList);
          if (this.loading_more[index].refresh_flag) {
            const loading_object = this.loading_more[index];
            loading_object.refresh_flag = false;
            this.loading_more.splice(index, 1, loading_object);
          }
        } else {
          this.loading_more[index] = {loading_flag: false, page_num: page_num};
          let current_page_contents = this.categorys[index];
          current_page_contents = current_page_contents.concat(res.data.newsInfoList);
          this.categorys.splice(index, 1, current_page_contents);
        }
        this.$nextTick(() => {
            let ads = this.$refs.current[this.current_index].getElementsByClassName('ad-container');
            [].forEach.call(ads, (elem, index) => {
              switch ( index % 6) {
                case 0:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = `<iframe src='./sogou001.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>`;
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130; 
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
                case 1:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou002.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130; 
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
                case 2:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou003.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130; 
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>`;
                    elem.appendChild(ad);
                  }
                case 3:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou003.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130; 
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>`;
                    elem.appendChild(ad);
                  }
                case 4:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou003.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130; 
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>`;
                    elem.appendChild(ad);
                  }
                case 5:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou003.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130; 
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
              }
              // switch ( index % 5) {
              //   case 0:
              //     if (!elem.getElementsByClassName('iclicashAD').length) {
              //       let s1 = document.createElement('script');
              //       s1.className = 'iclicashAD';
              //       s1.src='//cdn.aiclk.com/jssdk/aisdk.js?aid=7141282';
              //       elem.appendChild(s1);
              //     }
              //     // elem.innerHTML = '<script type="text/javascript" class="iclicashAD" src="//cdn.aiclk.com/jssdk/aisdk.js?aid=7141282"><\/script>';
              //     break;
              //   case 1:
              //     if (!elem.getElementsByClassName('sogou-wrap').length) {
              //       let s2 = document.createElement('div');
              //       s2.className = 'sogou-wrap';
              //       s2.innerHTML = '<iframe src="https://mini.eastday.com/toutiaoh5/partner/gg_sogou.html?ggid=776704" frameborder="0" scrolling="no" width="100%" height="145"></iframe>'
              //       // s2.srcdoc = '<script type="text/javascript">var sogou_ad_id=991654;var sogou_ad_content_height=120;<\/script><script type="text/javascript" src="http://gif.lu.sogoucdn.com/wap/js/wp.js"><\/script>';
              //       // s2.src="https://mini.eastday.com/toutiaoh5/partner/gg_sogou.html?ggid=776704";
              //       elem.appendChild(s2);
              //     }
              //     // let s21 = document.createElement('script');
              //     // s21.text = 'var sogou_ad_id=991654;var sogou_ad_content_height=120;';
              //     // elem.appendChild(s21);
              //     // let s22 = document.createElement('script');
              //     // s22.src = 'http://gif.lu.sogoucdn.com/wap/js/wp.js';
              //     // elem.appendChild(s22);
              //     // elem.innerHTML = '<script type="text/javascript">var sogou_ad_id=991654;var sogou_ad_content_height=120;<\/script><script type="text/javascript" src="http://gif.lu.sogoucdn.com/wap/js/wp.js"><\/script>';
              //     break;
              //   case 2:
              //     if (!elem.getElementsByClassName('iclicashAD').length) {
              //       let s3 = document.createElement('script');
              //       s3.className = 'iclicashAD';
              //       s3.src='//cdn.aiclk.com/jssdk/aisdk.js?aid=7347298';
              //       elem.appendChild(s3);
              //     }
              //     // elem.innerHTML = '<script type="text/javascript" class="iclicashAD" src="//cdn.aiclk.com/jssdk/aisdk.js?aid=7347298"><\/script>';
              //     break;
              //   case 3:
              //     let s4 = document.createElement('script');
              //     s4.setAttribute('data-product', '20066');
              //     s4.setAttribute('data-android-channal', "qgsh5a2018110501xxl");
              //     s4.setAttribute('data-ios-channal', "qgsh5a2018110501xxl")
              //     s4.src = '//cdn.ipadview.com/jssdk/combo.bundle.js';
              //     elem.appendChild(s4);
              //     // elem.innerHTML = '<script type="text/javascript" data-product="20066" data-android-channal="qgsh5a2018110501xxl" data-ios-channal="qgsh5a2018110501xxl" src="//cdn.ipadview.com/jssdk/combo.bundle.js"><\/script>';
              //     break;
              //   case 4:
              //     if (!elem.getElementsByClassName('iclicashAD').length) {
              //       let s5 = document.createElement('script');
              //       s5.className = 'iclicashAD';
              //       s5.src = '//cdn.aiclk.com/jssdk/aisdk.js?aid=7248879';
              //       elem.appendChild(s5);
              //     }
              //     // elem.innerHTML = '<script type="text/javascript" class="iclicashAD" src="//cdn.aiclk.com/jssdk/aisdk.js?aid=7248879"><\/script>';
              //     break;
              // }
            })
        });
      }).catch(err => {
          if (this.loading_more[index].refresh_flag) {
            const loading_object = this.loading_more[index];
            loading_object.refresh_flag = false;
            this.loading_more.splice(index, 1, loading_object);
          }
      })
    },
    touchStart: function (e) {
      touch_start_X = e.touches[0].pageX;
      touch_start_Y = e.touches[0].pageY;
      timer = setInterval(() => { touch_time++; }, 100);
    },
    touchEnd: function (e) {
      let touch_move_X = e.changedTouches[0].pageX;
      let touch_move_Y = e.changedTouches[0].pageY;
      let x_distance = touch_move_X - touch_start_X;
      let y_distance = touch_move_Y - touch_start_Y;
      let ratio = Math.abs(y_distance / x_distance);
      // console.log('x_distance: ', x_distance);
      // console.log('y_distance: ', y_distance);
      // console.log("ratio: ", ratio);
      if (y_distance >= 40 && touch_time < 20 && ratio > 2.5 && this.$refs.current[this.current_index].scrollTop === 0 && this.loading_more[this.current_index].refresh_flag === false) {
        console.log('-------------刷新页面------------------');
        const loading_object = this.loading_more[this.current_index];
        loading_object.refresh_flag = true;
        this.loading_more.splice(this.current_index, 1, loading_object);
        this.getPageInfo(this.current_index, undefined);
      }
      clearInterval(timer);
      touch_time = 0;
    },
    divScrollHandler: function () {
      // console.log('divScrollHandler called');
      // console.log("this.$refs.current[this.current_index]: ", this.$refs.current[this.current_index]);
      const current_page = this.$refs.current[this.current_index];
      if (this.loading_more[this.current_index].loading_flag) {
        return ;
      } else {
        const scrollHeight = current_page.scrollHeight;
        const scrollTop = current_page.scrollTop;
        const clientHeight = current_page.clientHeight;
        // console.log('clientHeight: ', clientHeight);
        // console.log('scrollTop: ', scrollTop);
        // console.log('scrollHeight: ', scrollHeight);
        if (clientHeight + scrollTop >= scrollHeight - 5) {
          console.log('loading more...');
          this.loading_more[this.current_index].loading_flag = true;
          const story_list = this.categorys[this.current_index];
          let page_num = story_list && story_list.length && story_list[story_list.length - 1].id;
          this.getPageInfo(this.current_index, page_num);
        }
      }
    },
    // scrollHandler: function () {
    //   console.log('scrollHandler called');
    //   if (this.loading_more[this.current_index].loading_flag) {
    //     return ;
    //   } else {
    //     let scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
    //     let scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
    //     let windowHeight = 0;
    //     if (document.compatMode === 'CSS1Compat') {
    //       windowHeight = document.documentElement.clientHeight;
    //     } else {
    //       windowHeight = document.body.clientHeight;
    //     }

    //     if (document.body) {
    //       bodyScrollTop = document.body.scrollTop;
    //       bodyScrollHeight = document.body.scrollHeight;
    //     }
    //     if (document.documentElement) {
    //       documentScrollTop = document.documentElement.scrollTop;
    //       documentScrollHeight = document.documentElement.scrollHeight;
    //     }
    //     scrollTop = Math.max(bodyScrollTop, documentScrollTop);
    //     scrollHeight = Math.max(bodyScrollHeight, documentScrollHeight);

    //     if (windowHeight + scrollTop >= scrollHeight) {
    //       console.log('加载更多执行。。。');
    //       this.loading_more[this.current_index].page_num++;
    //       this.getPageInfo(this.current_index, this.loading_more[this.current_index].page_num);
    //     }
    //   }
    //   return false;
    // },
    throttle: function (func, wait, mustRun) {
      let timeout, startTime = new Date();
      return function () {
        let context = this, args = arguments, curTime = new Date();
        
        clearTimeout(timeout);
        if (curTime - startTime >= mustRun) {
          func.apply(context, args);
          startTime = curTime;
        } else {
          timeout = setTimeout(func, wait);
        }
      }
    },
    searchFilter: function (search_value) {
      console.log('search_value: ', search_value);
    },
    changeIndex: function (index) {
      console.log('index.vue changeIndex---index: ', index, " originIndex: ", this.current_index);
      if (this.current_index < index) {
        this.transitionName = 'slide-left';
      } else {
        this.transitionName = 'slide-right';
      }
      this.current_index = index;
      this.getPageInfo(this.current_index, undefined);
    },
    swipeLeft: function (event) {
      this.transitionName = 'slide-left';
      const index = this.current_index;
      const max_index = this.categorys.length - 1;
      if (index < max_index) {
        this.current_index = index + 1;
        this.getPageInfo(this.current_index, undefined);
      } else {
        // this.current_index = max_index;
      }

    },
    swipeRight: function () {
      console.log('swipeRight called');
      this.transitionName = "slide-right";
      const index = this.current_index;
      if (index > 0) {
        this.current_index = index - 1;
        this.getPageInfo(this.current_index, undefined);
      } else {
        // this.current_index = 0;
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: white;
}
#index {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.fixed-area {
  height: 6%;
  position: fixed;
  width: 100%;
  background-color: white;
  z-index: 999;
}
.v-touch {
    touch-action: pay-y!important;
    /* width: 100vw; */
    height: 100%;
    position: relative;
    overflow: hidden;
}
.current-page {
    /* width: 100vw; */
    height: 94%;
    /* 默认position为static时，前面元素display：none后当前元素会重绘，导致有闪屏现象；改为relative或者absolute可以避免对当前元素的重绘，消除抖动 */
    /* relative和absolute会跟随出现，产生类似滑动的效果；不过relative时默认进入初始位置在屏幕外，所以要设置最终位置为-100%，而absolute时默认初始位置在当前屏幕上，所以要第一帧要设置初始位置在100%*/
    position: absolute;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    left: 0;
    top: 6%;
    box-sizing: border-box;
}
.ad-container {
  /* border-bottom: 1px solid #eee; */
  padding: 8px 8px;
  padding-bottom: 0px;
  overflow: hidden;
  text-align: left;
}
/* .v-touch .slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  transform: translateX(100%);
}
.v-touch .slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
} */
.v-touch .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter-active, .slide-right-leave-active {
  transition: all .5s ease;
}
.v-touch .slide-left-enter, .slide-right-leave-active{
  opacity: 0;
  transform: translateX(100%);
}
.v-touch .slide-right-enter, .slide-left-leave-active{
  opacity: 0;
  transform: translateX(-100%);
}

.loading-text {
  padding: 10px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue